// extracted by extract-css-chunks-webpack-plugin
module.exports = {"input":"css-1eOX7bZR5u","input_labelText":"css-2lPSry-8td","label":"css-1NBdmMqiJW","label__checkout":"css-3XKUW9nny7","label__error":"css-l3mCnT40rU"};